<div class="iad-loading">
  <div class="iad-loading-ctn">
    <div class="iad-loading-ctn-loader"></div>
    <div class="iad-loading-ctn-label">{{ 'iadRedirectComponent.redirect.label' | translate }}</div>
  </div>
</div>